<div class="bp-modal mod-lg">
	<bp-modal-header [title]="'offline' | translate">
		<a right (click)="closeAll()" (keydown.enter)="closeAll()" [tabIndex]="0">{{ "close" | translate }}</a>
	</bp-modal-header>
	<div class="bp-modal-body">
		<div class="bp-modal-body-section pt-10">
			<div class="justify-center mb-20">
				<img
					class="offline-panda"
					src="assets/images/404-panda.png"
					alt="{{ '404_not_found_title' | translate }}" />
			</div>
			<h2 class="font-size-24 font-bold text-center">{{ "you_seem_to_be_offline_title" | translate }}</h2>
			<p class="text-center text-light mb-30">{{ "you_seem_to_be_offline_text" | translate }}</p>
			<div class="text-center">
				<a
					[href]="baseUrl"
					class="modal-add-info-button btn btn-primary btn-bold btn-bigger-text"
					tabindex="501"
					(click)="save()"
					type="button">
					{{ "click_here_to_reload" | translate }}
				</a>
			</div>
		</div>
	</div>
</div>
